// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chatbot.container {
  max-width: 500px;
  margin: 0 auto;
  height: 80vh;
  display: flex;
  flex-direction: column;
  position: absolute;
  right: 10px;
  bottom: 10px;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem;
  background-color: var(--bg-color);
  border-bottom: 1px solid var(--border-color);
  box-shadow: var(--shadow-sm);
}

.header-title {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.header-title h1 {
  font-size: 1.5rem;
  font-weight: 600;
}

.bot-status {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.875rem;
  color: var(--text-secondary);
}

.status-indicator {
  width: 8px;
  height: 8px;
  background: #10b981;
  border-radius: 50%;
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.2);
    opacity: 0.7;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

.controls {
  display: flex;
  gap: 1rem;
}

.theme-toggle {
  background: none;
  border: none;
  cursor: pointer;
  color: var(--text-primary);
  font-size: 1.25rem;
  padding: 0.5rem;
  border-radius: 0.5rem;
  transition: all 0.3s ease;
}

.theme-toggle:hover {
  background-color: var(--bot-message-bg);
}
/* ================= */
.chat-container {
  width: 370px;
  height: 550px;
  background: #ffffff;
  border-radius: 15px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.chat-header {
  background: #8e0007;
  color: white;
  padding: 16px;
  font-size: 18px;
  font-weight: bold;
  text-align: center;
}

.chat-messages {
  flex: 1 1;
  padding: 15px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.message-wrapper {
  display: flex;
  flex-direction: column;
  /* max-width: 75%; */
}

.bot-message {
  background-color: #f1f0f0;
  align-self: flex-start;
  border-radius: 18px;
  padding: 10px 15px;
  max-width: 80%;
}

.timestamp {
  font-size: 11px;
  color: #777;
  margin-top: 4px;
  text-align: right;
}

.chat-input {
  display: flex;
  padding: 10px;
  /* border-top: 1px solid #ddd; */
  background: #fafafa;
}

.chat-input input {
  flex: 1 1;
  padding: 10px;
  border-radius: 20px;
  border: 1px solid #ccc;
  outline: none;
}

.chat-input button {
  margin-left: 10px;
  background: #8e0007;
  border: none;
  color: white;
  padding: 10px 15px;
  border-radius: 20px;
  cursor: pointer;
}

.tag-list {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 10px;
}

.tag {
  padding: 8px 12px;
  background-color: #f1f0f0;
  color: #333;
  border: none;
  border-radius: 16px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
}
/* ================ */

.message {
  display: flex;
  align-items: flex-start;
  margin-bottom: 1.5rem;
  opacity: 0;
  transform: translateY(20px);
  animation: messageAppear 0.5s ease forwards;
}

@keyframes messageAppear {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.avatar {
  width: 40px;
  height: 40px;
  border-radius: 12px;
  margin-right: 1rem;
  background: var(--primary-gradient);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: 600;
  box-shadow: var(--shadow-md);
}

.user-message .avatar {
  background: var(--secondary-gradient);
}

.message-bubble {
  max-width: 70%;
  padding: 1rem 1.5rem;
  border-radius: 1rem;
  box-shadow: var(--shadow-sm);
  line-height: 1.5;
  position: relative;
}

.bot-message .message-bubble {
  background-color: var(--bot-message-bg);
  border-top-left-radius: 0;
}

.user-message {
  flex-direction: row-reverse;
  background-color: #f1f0f0;
  align-self: flex-end;
  border-radius: 18px;
  padding: 10px 15px;
  max-width: 80%;
}

.user-message .avatar {
  margin-right: 0;
  margin-left: 1rem;
}

.user-message .message-bubble {
  background: var(--user-message-bg);
  color: white;
  border-top-right-radius: 0;
}

.typing-indicator {
  display: none;
  padding: 1rem 1.5rem;
  background-color: var(--bot-message-bg);
  border-radius: 1rem;
  width: fit-content;
  margin-left: 3.5rem;
  box-shadow: var(--shadow-sm);
}

.typing-dots {
  display: flex;
  gap: 0.4rem;
}

.typing-dot {
  width: 8px;
  height: 8px;
  background-color: var(--text-secondary);
  border-radius: 50%;
  animation: typingBounce 1.4s infinite ease-in-out;
}

.typing-dot:nth-child(1) {
  animation-delay: -0.32s;
}
.typing-dot:nth-child(2) {
  animation-delay: -0.16s;
}

@keyframes typingBounce {
  0%,
  80%,
  100% {
    transform: scale(0);
  }
  40% {
    transform: scale(1);
  }
}

.input-container {
  padding: 1.5rem;
  background-color: var(--bg-color);
  border-top: 1px solid var(--border-color);
  box-shadow: var(--shadow-lg);
}

.input-wrapper {
  display: flex;
  gap: 1rem;
  background-color: var(--chat-bg);
  border-radius: 1rem;
  padding: 0.5rem;
  box-shadow: var(--shadow-sm);
}

.message-input {
  flex: 1 1;
  padding: 0.75rem 1rem;
  border: none;
  background: none;
  color: var(--text-primary);
  font-size: 1rem;
}

.message-input:focus {
  outline: none;
}

.message-input::placeholder {
  color: var(--text-secondary);
}

.action-buttons {
  display: flex;
  gap: 0.5rem;
  padding: 0.5rem;
}

.action-button {
  background: none;
  border: none;
  padding: 0.75rem;
  color: var(--text-secondary);
  cursor: pointer;
  border-radius: 0.5rem;
  transition: all 0.3s ease;
}

.action-button:hover {
  background-color: var(--bot-message-bg);
  color: var(--text-primary);
}

.send-button {
  background: #f73508;
  color: white;
  border: none;
  padding: 0.75rem 1.5rem;
  border-radius: 0.5rem;
  cursor: pointer;
  transition: all 0.3s ease;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.send-button:hover {
  opacity: 0.9;
  transform: translateY(-1px);
}

@media (max-width: 768px) {
  /* .container {
    height: 100dvh;
  } */

  .header-title h1 {
    font-size: 1.25rem;
  }

  .chat-container {
    padding: 1rem;
  }

  .message-bubble {
    max-width: 85%;
  }

  .input-container {
    padding: 1rem;
  }
}
.chat-clear {
  display: flex;
  justify-content: center;
  margin: 10px 0;
}

.clear-button {
  background: #8e0007;
  color: white;
  border: none;
  padding: 8px 16px;
  cursor: pointer;
  border-radius: 5px;
  /* font-weight: bold; */
}
`, "",{"version":3,"sources":["webpack://./src/features/view/public/Chatbot/Chatbot.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,cAAc;EACd,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,iCAAiC;EACjC,4CAA4C;EAC5C,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE;IACE,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,qBAAqB;IACrB,YAAY;EACd;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;AACF;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,0BAA0B;EAC1B,kBAAkB;EAClB,eAAe;EACf,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,uCAAuC;AACzC;AACA,sBAAsB;AACtB;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,yCAAyC;EACzC,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iCAAiC;AACnC;AACA,qBAAqB;;AAErB;EACE,aAAa;EACb,uBAAuB;EACvB,qBAAqB;EACrB,UAAU;EACV,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,mCAAmC;EACnC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,4BAA4B;EAC5B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,uCAAuC;EACvC,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kCAAkC;EAClC,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,uCAAuC;EACvC,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,UAAU;EACV,WAAW;EACX,uCAAuC;EACvC,kBAAkB;EAClB,iDAAiD;AACnD;;AAEA;EACE,uBAAuB;AACzB;AACA;EACE,uBAAuB;AACzB;;AAEA;EACE;;;IAGE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,eAAe;EACf,iCAAiC;EACjC,yCAAyC;EACzC,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gCAAgC;EAChC,mBAAmB;EACnB,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,SAAO;EACP,qBAAqB;EACrB,YAAY;EACZ,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,4BAA4B;EAC5B,eAAe;EACf,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,uCAAuC;EACvC,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,qBAAqB;EACrB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE;;KAEG;;EAEH;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;AACF;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,uBAAuB;AACzB","sourcesContent":[".chatbot.container {\n  max-width: 500px;\n  margin: 0 auto;\n  height: 80vh;\n  display: flex;\n  flex-direction: column;\n  position: absolute;\n  right: 10px;\n  bottom: 10px;\n}\n\n.header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 1.5rem;\n  background-color: var(--bg-color);\n  border-bottom: 1px solid var(--border-color);\n  box-shadow: var(--shadow-sm);\n}\n\n.header-title {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n.header-title h1 {\n  font-size: 1.5rem;\n  font-weight: 600;\n}\n\n.bot-status {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  font-size: 0.875rem;\n  color: var(--text-secondary);\n}\n\n.status-indicator {\n  width: 8px;\n  height: 8px;\n  background: #10b981;\n  border-radius: 50%;\n  animation: pulse 2s infinite;\n}\n\n@keyframes pulse {\n  0% {\n    transform: scale(1);\n    opacity: 1;\n  }\n  50% {\n    transform: scale(1.2);\n    opacity: 0.7;\n  }\n  100% {\n    transform: scale(1);\n    opacity: 1;\n  }\n}\n\n.controls {\n  display: flex;\n  gap: 1rem;\n}\n\n.theme-toggle {\n  background: none;\n  border: none;\n  cursor: pointer;\n  color: var(--text-primary);\n  font-size: 1.25rem;\n  padding: 0.5rem;\n  border-radius: 0.5rem;\n  transition: all 0.3s ease;\n}\n\n.theme-toggle:hover {\n  background-color: var(--bot-message-bg);\n}\n/* ================= */\n.chat-container {\n  width: 370px;\n  height: 550px;\n  background: #ffffff;\n  border-radius: 15px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.chat-header {\n  background: #8e0007;\n  color: white;\n  padding: 16px;\n  font-size: 18px;\n  font-weight: bold;\n  text-align: center;\n}\n\n.chat-messages {\n  flex: 1;\n  padding: 15px;\n  overflow-y: auto;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.message-wrapper {\n  display: flex;\n  flex-direction: column;\n  /* max-width: 75%; */\n}\n\n.bot-message {\n  background-color: #f1f0f0;\n  align-self: flex-start;\n  border-radius: 18px;\n  padding: 10px 15px;\n  max-width: 80%;\n}\n\n.timestamp {\n  font-size: 11px;\n  color: #777;\n  margin-top: 4px;\n  text-align: right;\n}\n\n.chat-input {\n  display: flex;\n  padding: 10px;\n  /* border-top: 1px solid #ddd; */\n  background: #fafafa;\n}\n\n.chat-input input {\n  flex: 1;\n  padding: 10px;\n  border-radius: 20px;\n  border: 1px solid #ccc;\n  outline: none;\n}\n\n.chat-input button {\n  margin-left: 10px;\n  background: #8e0007;\n  border: none;\n  color: white;\n  padding: 10px 15px;\n  border-radius: 20px;\n  cursor: pointer;\n}\n\n.tag-list {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-top: 10px;\n}\n\n.tag {\n  padding: 8px 12px;\n  background-color: #f1f0f0;\n  color: #333;\n  border: none;\n  border-radius: 16px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n/* ================ */\n\n.message {\n  display: flex;\n  align-items: flex-start;\n  margin-bottom: 1.5rem;\n  opacity: 0;\n  transform: translateY(20px);\n  animation: messageAppear 0.5s ease forwards;\n}\n\n@keyframes messageAppear {\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.avatar {\n  width: 40px;\n  height: 40px;\n  border-radius: 12px;\n  margin-right: 1rem;\n  background: var(--primary-gradient);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n  font-weight: 600;\n  box-shadow: var(--shadow-md);\n}\n\n.user-message .avatar {\n  background: var(--secondary-gradient);\n}\n\n.message-bubble {\n  max-width: 70%;\n  padding: 1rem 1.5rem;\n  border-radius: 1rem;\n  box-shadow: var(--shadow-sm);\n  line-height: 1.5;\n  position: relative;\n}\n\n.bot-message .message-bubble {\n  background-color: var(--bot-message-bg);\n  border-top-left-radius: 0;\n}\n\n.user-message {\n  flex-direction: row-reverse;\n  background-color: #f1f0f0;\n  align-self: flex-end;\n  border-radius: 18px;\n  padding: 10px 15px;\n  max-width: 80%;\n}\n\n.user-message .avatar {\n  margin-right: 0;\n  margin-left: 1rem;\n}\n\n.user-message .message-bubble {\n  background: var(--user-message-bg);\n  color: white;\n  border-top-right-radius: 0;\n}\n\n.typing-indicator {\n  display: none;\n  padding: 1rem 1.5rem;\n  background-color: var(--bot-message-bg);\n  border-radius: 1rem;\n  width: fit-content;\n  margin-left: 3.5rem;\n  box-shadow: var(--shadow-sm);\n}\n\n.typing-dots {\n  display: flex;\n  gap: 0.4rem;\n}\n\n.typing-dot {\n  width: 8px;\n  height: 8px;\n  background-color: var(--text-secondary);\n  border-radius: 50%;\n  animation: typingBounce 1.4s infinite ease-in-out;\n}\n\n.typing-dot:nth-child(1) {\n  animation-delay: -0.32s;\n}\n.typing-dot:nth-child(2) {\n  animation-delay: -0.16s;\n}\n\n@keyframes typingBounce {\n  0%,\n  80%,\n  100% {\n    transform: scale(0);\n  }\n  40% {\n    transform: scale(1);\n  }\n}\n\n.input-container {\n  padding: 1.5rem;\n  background-color: var(--bg-color);\n  border-top: 1px solid var(--border-color);\n  box-shadow: var(--shadow-lg);\n}\n\n.input-wrapper {\n  display: flex;\n  gap: 1rem;\n  background-color: var(--chat-bg);\n  border-radius: 1rem;\n  padding: 0.5rem;\n  box-shadow: var(--shadow-sm);\n}\n\n.message-input {\n  flex: 1;\n  padding: 0.75rem 1rem;\n  border: none;\n  background: none;\n  color: var(--text-primary);\n  font-size: 1rem;\n}\n\n.message-input:focus {\n  outline: none;\n}\n\n.message-input::placeholder {\n  color: var(--text-secondary);\n}\n\n.action-buttons {\n  display: flex;\n  gap: 0.5rem;\n  padding: 0.5rem;\n}\n\n.action-button {\n  background: none;\n  border: none;\n  padding: 0.75rem;\n  color: var(--text-secondary);\n  cursor: pointer;\n  border-radius: 0.5rem;\n  transition: all 0.3s ease;\n}\n\n.action-button:hover {\n  background-color: var(--bot-message-bg);\n  color: var(--text-primary);\n}\n\n.send-button {\n  background: #f73508;\n  color: white;\n  border: none;\n  padding: 0.75rem 1.5rem;\n  border-radius: 0.5rem;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.send-button:hover {\n  opacity: 0.9;\n  transform: translateY(-1px);\n}\n\n@media (max-width: 768px) {\n  /* .container {\n    height: 100dvh;\n  } */\n\n  .header-title h1 {\n    font-size: 1.25rem;\n  }\n\n  .chat-container {\n    padding: 1rem;\n  }\n\n  .message-bubble {\n    max-width: 85%;\n  }\n\n  .input-container {\n    padding: 1rem;\n  }\n}\n.chat-clear {\n  display: flex;\n  justify-content: center;\n  margin: 10px 0;\n}\n\n.clear-button {\n  background: #8e0007;\n  color: white;\n  border: none;\n  padding: 8px 16px;\n  cursor: pointer;\n  border-radius: 5px;\n  /* font-weight: bold; */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
